"use client";

import { Box, Button, Stack, Typography } from "@mui/material";
import { useRouter } from "next/navigation";
import { useTranslation } from "react-i18next";
import { IMAGES } from "../constants/images";
import NextLink from "next/link";
export default function LandingPageYellowCTA() {
    const router = useRouter();
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language === "ar";

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                position: "relative",
                overflow: "hidden",
                width: "100%",
                mx: 0,
                px: 0,
                mb: "2%",
                mt: { xs: isArabic ? "3%" : "2%", sm: "2%" },
                height: { xs: isArabic ? "25vh" : "45vh", sm: "45vh" },
            }}
        >
            {/* Background Video */}
            <Box
                component="img"
                src="https://getgeek-website-assets.b-cdn.net/Yellow%20CTA.webp"
                alt="Yellow CTA background"
                loading="lazy"
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    zIndex: 0,
                }}
            />

            {/* Main Heading */}
            <Typography
                sx={{
                    position: "relative",
                    zIndex: 1,
                    fontSize: { xs: "18px", md: "28px", lg: "32px" },
                    color: "#2A4A45",
                    fontFamily: "var(--font-outfit)",
                    fontWeight: "700",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                    flexWrap: "wrap",
                }}
            >
                {t("socialProof.ctaLabelYellowCTA")}
                <Box
                    component="img"
                    src={
                        isArabic ? IMAGES.YELLOW_ARROW_ARABIC_IMG : IMAGES.YELLOW_ARROW_IMG
                    }
                    alt="arrow"
                    sx={{
                        width: { xs: "22px", md: "32px", lg: "36px" },
                        height: { xs: "22px", md: "32px", lg: "36px" },
                        objectFit: "contain",
                        display: "inline-block",
                        verticalAlign: "middle",
                        mb: { xs: "2px", md: "4px" },
                        "@keyframes bounceRotate": {
                            "0%": { transform: "translateY(0px) rotate(0deg)" },
                            "20%": { transform: "translateY(-6px) rotate(-8deg)" },
                            "40%": { transform: "translateY(0px) rotate(8deg)" },
                            "60%": { transform: "translateY(-3px) rotate(-4deg)" },
                            "80%": { transform: "translateY(0px) rotate(4deg)" },
                            "100%": { transform: "translateY(0px) rotate(0deg)" },
                        },
                        animation: "bounceRotate 2.5s ease-in-out infinite",
                    }}
                />
            </Typography>

            {/* Subtitle */}
            <Typography
                sx={{
                    position: "relative",
                    zIndex: 1,
                    fontSize: { xs: "13px", md: "16px", lg: "18px" },
                    color: "#555",
                    fontFamily: "var(--font-outfit)",
                    fontWeight: "400",
                    mt: "10px",
                    maxWidth: 700
                }}
            >
                {t("socialProof.ctaSubtitleYellowCTA")}
            </Typography>

            <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={{ xs: 1.5, sm: 2 }}
                alignItems={{ xs: "stretch", sm: "center" }}
                sx={{ position: "relative", zIndex: 1, mt: "2%" }}
            >
                <NextLink href="/free-trial-of-ai-recruiting-tool" passHref legacyBehavior>
                    <Button
                        component="a"
                        sx={{
                            bgcolor: "#F6AC03",
                            color: "#fff",
                            textTransform: "none",
                            px: { xs: 3, sm: 3.5, md: 4 },
                            py: { xs: 1.5, sm: 1.6, md: 1.5 },
                            height: { xs: "48px", sm: "52px", md: "55px" },
                            fontFamily: "var(--font-outfit)",
                            fontSize: { xs: "0.875rem", sm: "0.95rem", lg: "1rem" },
                            fontWeight: "500",
                            borderRadius: "28px",
                            boxShadow: "none",
                            transition: "all 0.3s ease-in-out",
                            "&:hover": {
                                bgcolor: "#000",
                                color: "#fff",
                                transform: "scale(1.05)",
                            },
                        }}
                    >
                        {t("socialProof.ctaYellowBtn")}
                    </Button>
                </NextLink>
            </Stack>
        </Box>
    );
}
